import { NgModule } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { materialModules } from '../../../angular-material.module';
import { CreateBusinessComponent } from './create-business/create-business.component';
import { BusinessCreateSubscriptionComponent } from './business-create-subscription/business-create-subscription.component';
import { BusinessValidateSubscriptionComponent } from './business-validate-subscription/business-validate-subscription.component';
import { BusinessSubscriptionComponent } from './business-subscription/business-subscription.component';
import { BusinessTrialStartComponent } from './business-trial-start/business-trial-start.component';
import { SharedModule } from "../../../shared/shared.module";
import { TippyModule } from '@ngneat/helipopper';

@NgModule({
	imports: [CommonModule, FormsModule, RouterModule, MatDialogModule, ReactiveFormsModule, ...materialModules, SharedModule, TippyModule],
	declarations: [
		CreateBusinessComponent,
		BusinessCreateSubscriptionComponent,
		BusinessValidateSubscriptionComponent,
		BusinessSubscriptionComponent,
		BusinessTrialStartComponent,
	],
	exports: [
		CreateBusinessComponent,
		BusinessCreateSubscriptionComponent,
		BusinessValidateSubscriptionComponent,
		BusinessTrialStartComponent
	]
})
export class BusinessModule {}
